export default "/dist/files/overlay-avatar.e8060aeecf65edc9f7b1ed99970278c2.svg";